import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";

export default function Contact() {
  return (
    <div className="relative z-10 min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <div className="px-6 md:px-16 py-16 md:py-24 max-w-4xl mx-auto" data-testid="contact-page">
        <p className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] text-center mb-6">Contact</p>
        <p data-testid="contact-launch" className="text-center text-sm uppercase tracking-[0.3em] text-[#8B5A2B] mb-12 mt-2">
          Launching Dec 2026
        </p>

        <div className="max-w-md mx-auto rounded-2xl border border-[#6D214F]/25 bg-[#6D214F]/5 p-8 text-center">
          <p className="font-serif-display text-2xl text-[#1A1A1A] mb-5">Be first in line.</p>
          <Link
            to="/try-on"
            data-testid="contact-cta"
            className="inline-flex items-center justify-center bg-[#1A1A1A] text-[#FDFBF7] text-xs uppercase tracking-[0.2em] px-8 py-3.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
          >
            Join the Waitlist
          </Link>
        </div>
      </div>
    </div>
  );
}
